// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2UB5c","alert":"SettungsInbox_alert__s-PAa"};